import * as angular from "angular";
import {IController} from "angular";
import {SelectFilterType} from "../../types/select-filter.type";

export class BringozMultiSelectComponent implements IController {

  type: string;
  name: string;
  options: string[];
  optionIds: string[];
  excludedIds: string[];
  values: string[];
  isRequired: boolean;
  isDisabled: boolean;
  ngPlaceholder: string;
  selectParams: any;
  onSelect: Function;

  public selectFilterType: typeof SelectFilterType = SelectFilterType;

  constructor() {
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozMultiSelect', {
    bindings: {
      type: '<',
      name: '@?',
      options: '<',
      optionIds: '<?',
      excludedIds: '<?',
      values: '<',
      isRequired: '<?',
      isDisabled: '<?',
      selectParams: '<?',
      ngPlaceholder: '@?',
      onSelect: '&'
    },
    template: require('./bringoz-multi-select.html').default,
    controller: BringozMultiSelectComponent
  });

